// @flow
import {
    attemptDeleteRecipe,
    attemptUpdateRecipe,
    cancelAction,
    editRecipe,
    editSchedule,
    requestConfirmDelete
} from '~/core/state/recipes/actions';

import { connect } from 'react-redux';
import { hasSMS } from '~/core/state/entitlements/selectors';
import { isConsumerActive } from '~/core/utils/recipes';
import { makeGetProductItemById } from '~/core/state/products/selectors';
import { notificationTypes } from '~/core/constants/recipes';
import RecipeItem from './component';

const NOTIFICATION = 'NOTIFICATION';

const mapStateToProps = (state, { recipe }) => {
    const getProductItemById = makeGetProductItemById();

    const consumerProduct = getProductItemById(state, {
        id: recipe.getIn(['data', 'consumer'])
    });
    const producerProduct = getProductItemById(state, {
        id: recipe.getIn(['data', 'producer'])
    });

    let notificationOptions, consumer;
    if (recipe.getIn(['data', 'action', 'type']) === NOTIFICATION) {
        notificationOptions = recipe.getIn(['data', 'action', 'value']);
        if (!hasSMS(state) && notificationOptions.get(notificationTypes.sms)) {
            notificationOptions = notificationOptions.set(notificationTypes.sms, false);
        }
    } else if (consumerProduct) {
        const type = consumerProduct.get('type');
        consumer = {
            duration: recipe.getIn(['data', 'action', 'duration']),
            isActive: isConsumerActive(recipe, type),
            name: consumerProduct.getIn(['state', 'name']),
            state: recipe.getIn(['data', 'action', 'changes']),
            type
        };
    }
    const producer = {
        name: producerProduct.getIn(['state', 'name']),
        trigger: recipe.getIn(['data', 'trigger', 'eventName']),
        type: producerProduct.get('type')
    };

    const isEnabled = recipe.getIn(['data', 'enabled']);
    const isScheduled = recipe.getIn(['data', 'scheduled']);
    const status = recipe.get('status');

    return {
        consumer,
        isEnabled,
        isScheduled,
        notificationOptions,
        producer,
        status
    };
};

const mapDispatchToProps = {
    attemptDeleteRecipe,
    attemptUpdateRecipe,
    cancelAction,
    editRecipe,
    editSchedule,
    requestConfirmDelete
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const {
        attemptDeleteRecipe,
        attemptUpdateRecipe,
        cancelAction,
        editRecipe,
        editSchedule,
        requestConfirmDelete
    } = dispatchProps;
    const { consumer = {}, isEnabled } = stateProps;
    const { recipe } = ownProps;

    return {
        ...stateProps,
        cancelAction: () => cancelAction(recipe.getIn(['data', 'id'])),
        confirmDelete: () => attemptDeleteRecipe(recipe.getIn(['data', 'id'])),
        deleteRecipe: () => requestConfirmDelete(recipe.getIn(['data', 'id'])),
        editRecipe: () =>
            editRecipe({
                recipeData: recipe.get('data'),
                consumerType: consumer.type
            }),
        showSchedule: () =>
            editSchedule({
                recipeData: recipe.get('data'),
                consumerType: consumer.type
            }),
        toggleRecipeStatus: () => attemptUpdateRecipe(recipe.setIn(['data', 'enabled'], !isEnabled))
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RecipeItem);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-item/index.js